import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-user-picker',
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.css']
})
export class UserPickerComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<object>();

  activeIndex: number = -1;
  users: ListItem[];
  usersFiltered: ListItem[];
  public componentForm: FormGroup = new FormGroup({});
  public searchInput: FormControl = new FormControl('');

  constructor() { }

  ngOnInit(): void {
    this.users = this.payload['users']
    this.users.sort((a: ListItem, b: ListItem) => {
      const compA = parseInt(a.itemFullData['rank']);
      const compB = parseInt(b.itemFullData['rank']);
      return (compA === compB) ? 0 : ((compA > compB) ? -1 : 1);
    })
    this.usersFiltered = [...this.users];
    this.componentForm.addControl('searchInput',this.searchInput);
    this.searchInput.valueChanges.subscribe(value => {
      this.filterList(value)
    })
  }

  filterList(filterValue:string): void {
    if (!filterValue) {
      this.usersFiltered = [...this.users];
    } else {
      this.usersFiltered = [...this.users.filter(user => user.filter_string.indexOf(filterValue) != -1 )]
    }
  }

  userPicked(): void {
    this.success.emit({user: this.usersFiltered[this.activeIndex]})
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

}
